import { Injectable } from '@angular/core';
import { HubLoanerPhoneListItem, YardSpotConfigurationModel } from '../../../../administration/hub/models';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel, AllocationViewUliCarrierModel, UliDetailsModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { delay, filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  AllocationViewRegisterActionPrepare,
  AllocationViewRegisterActionUliRegister,
  AllocationViewRegisterActionLoadCarries,
  AllocationViewRegisterActionLoadLoanerPhones,
  AllocationViewRegisterActionSetInitialState,
  AllocationViewRegisterActionLoadParkingSpots,
} from './allocation-view-register-action.actions';

import { AllocationViewRegisterActionState } from './allocation-view-register-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewRegisterActionFacade implements AllocationViewActionInterface {
  details$: Observable<UliDetailsModel> = this.store.select(AllocationViewRegisterActionState.getDetails);
  loanerPhones$: Observable<HubLoanerPhoneListItem[]> = this.store.select(
    AllocationViewRegisterActionState.getLoanerPhones,
  );
  carriers$: Observable<AllocationViewUliCarrierModel[]> = this.store.select(
    AllocationViewRegisterActionState.getCarriers,
  );
  parkingSpots$: Observable<YardSpotConfigurationModel[]> = this.store.select(
    AllocationViewRegisterActionState.getParkingSpots,
  );
  loaded$: Observable<boolean> = this.store.select(AllocationViewRegisterActionState.getLoaded);
  canSaveFrequentDriver$ = new BehaviorSubject<boolean>(true);

  constructor(private store: Store, private allocationViewActionsFacade: AllocationViewActionsFacade) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewRegisterActionSetInitialState());
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(delay(0), filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) =>
        this.store.dispatch(new AllocationViewRegisterActionPrepare(identifier)),
      );
  }

  uliRegister(uli: UliDetailsModel): void {
    this.store.dispatch(new AllocationViewRegisterActionUliRegister({ uli }));
  }

  getCarriers(searchStr: string): void {
    this.store.dispatch(new AllocationViewRegisterActionLoadCarries(searchStr));
  }

  getLoanerPhones(hubId: number, searchStr: string): void {
    this.store.dispatch(
      new AllocationViewRegisterActionLoadLoanerPhones({
        hubId,
        searchStr,
      }),
    );
  }

  getParkingSpots(hubId: number): void {
    this.store.dispatch(new AllocationViewRegisterActionLoadParkingSpots(hubId));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewRegisterActionSetInitialState());
  }
}
